import { Style } from '../../@shared/models/style.model';
import { Clickable } from '../../@shared/models/clickable.model';
import { Type } from 'class-transformer';
import { Iconable } from '../../@shared/models/iconable.model';
import { CText } from '../../@shared/models/text.model';

export class LPHeader {
    layout: string;
    layoutContent: string;
    styles: Array<Style>;
    text: string;
    action?: Clickable | null;
    banner: Banner | null;
    timerStrip: any;

    constructor() {
        this.layout = '';
        this.layoutContent = '';
        if (this.layout === '') {
            this.layout = 'circle';
        }
        this.text = '';
        this.styles = [];
        this.action = null;
        this.banner = null;
    }
}
export interface Banner {
    image: string;
    scrim?: { color: string; alpha: string };
    video?: string;
    link: string;
}
export class ListingFiltersSubItem {
    text?: string;
    image?: string;
    link?: string;

    constructor() {
        this.text = '';
        this.image = '';
        this.link = '';
    }
}

export class ListingFiltersItem {
    active: number;
    text: string;
    layout: string;
    @Type(() => ListingFiltersSubItem)
    feed: Array<ListingFiltersSubItem>;

    constructor() {
        this.active = 0;
        this.text = '';
        this.layout = '';
        this.feed = [];
    }
}

export class ListingFiltersContent {
    text: string;
    @Type(() => ListingFiltersItem)
    feed: Array<ListingFiltersItem>;

    constructor() {
        this.text = '';
        this.feed = [];
    }
}

export class Filters {
    active: number;
    @Type(() => ListingFiltersContent)
    feed: Array<ListingFiltersContent>;
    leftButton: Clickable;
    rightButton: Clickable;
    icon: string;
    link: string;

    constructor() {
        this.active = 0;
        this.feed = [];
        this.leftButton = { text: '', link: '' };
        this.rightButton = { text: '', link: '' };
        this.icon = '';
        this.link = '';
    }

    update(value: any) {
        this.active = value.action;
        this.feed = value.feed;
        this.leftButton = value.leftButton;
        this.rightButton = value.rightButton;
    }
}

export class LPContentItem {
    layout: string;
    layoutType: string;
    id: string;
    link: string;
    title: CText;
    subtitle: CText;
    image: string;
    altImage: string;
    overlay: {
        background: string;
        title: {
            color: string;
            text: string;
        };
    };
    price: CText;
    mrp: CText;
    button: Iconable;
    banner: {
        image: string;
        link: string;
        scrim: { color: string; alpha: string };
        video?: string;
    };
    productBgColor?: string;

    constructor() {
        this.layout = 'square';
        this.layoutType = '';
        this.id = '';
        this.link = '';
        this.image = '';
        this.altImage = '';
        this.title = { text: '' };
        this.subtitle = { text: '' };
        this.overlay = {
            background: '',
            title: {
                color: '',
                text: '',
            },
        };
        this.banner = {
            image: '',
            link: '',
            scrim: {
                color: '',
                alpha: '',
            },
            video: '',
        };
        this.price = { text: '' };
        this.mrp = { text: '' };
        this.button = {
            icon: '',
            link: '',
        };
    }

    update(value: any) {
        this.layout = value.layout;
        this.id = value.id;
        this.link = value.link;
        this.title = value.title;
        this.subtitle = value.subtitle;
        this.image = value.image;
        this.overlay = value.overlay;
        this.price = value.price;
        this.mrp = value.mrp;
        this.button = value.button;
    }
}

export class LPContent {
    feed?: LPContentItem[];
    activeProducts?: number;
    oosProducts?: number;

    constructor() {
        this.feed = [];
        this.activeProducts = 0;
        this.oosProducts = 0;
    }
}

export class LPSEO {
    seoTable: TableData;
    breadCrumbs: Array<{
        item: string;
        link: string;
        name: string;
        position: number;
        text: string;
        type: string;
    }>;
    canonical: string;
    footerContent?: any | null;
    meta?: any;
    ogImage: string;
    langAlternates: Array<{
        href: string;
        hreflang: string;
    }>;
    faq: Array<any>;

    constructor() {
        this.seoTable = { text: '', header: [], rows: [], description: '' };
        this.langAlternates = [];
        this.canonical = '';
        this.ogImage = '';
        this.breadCrumbs = [];
        this.faq = [];
    }
}
export interface TableData {
    text: string;
    header: string[];
    rows: Array<Clickable[]>;
    description: string;
}

export interface LPBody {
    onlyActive?: number;
    onlyOOS?: number;
}
